import type { CareerMoveActionResult } from "@career-ops-amplify/shared";

type Props = {
  feedback: CareerMoveActionResult | null;
  onDismiss: () => void;
};

export function CareerMoveExecutionFeedback({ feedback, onDismiss }: Props) {
  if (!feedback) return null;
  return (
    <div className="mb-3 flex items-center justify-between rounded-md border border-border bg-muted/20 px-3 py-2 text-sm">
      <span className="text-foreground">
        {feedback.message ?? `Action ${feedback.action} recorded`}
      </span>
      <button
        type="button"
        onClick={onDismiss}
        className="text-xs text-muted-foreground hover:text-foreground"
      >
        Dismiss
      </button>
    </div>
  );
}
